<template>
  <div ref="slideshowToolbar">
    slideshow
    {{ new Date() }}
  </div>
</template>

<script>
import Toolbar from '@/mixins/topologymap/toolbar';

export default {
  name: 'WTopologymapSlideShow',
  mixins: [Toolbar],
  data() {
    return {
    };
  },
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/layout/TopologymapSlideShow.vue